<header class="sticky top-0 z-10 bg-white">
    <nav class="navigation" [class.scrolled]="isScrolled" aria-label="Global">
        <div class="flex-none">
            <a [href]="homeUrl()">
                <span class="sr-only">Packbo</span>
                <img
                    class="navigation-logo"
                    ngSrc="assets/images/packbo-logo-color.svg"
                    alt="Packbo Logo"
                    width="129"
                    height="100"
                />
                <img
                    class="navigation-logo-mobile"
                    ngSrc="assets/images/packbo-logo-wide-color.svg"
                    alt="Packbo Logo"
                    width="160"
                    height="48"
                />
            </a>
        </div>
        <div class="hidden flex-1 items-center justify-center gap-x-10 text-center lg:flex">
            <div class="flex-initial">
                <button
                    type="button"
                    class="text-title-small text-neutral-20 hover:text-neutral-30 flex cursor-pointer items-center gap-x-1"
                    [attr.aria-expanded]="isMenuOpen"
                    (click)="toggleMenu()"
                >
                    {{ "navigation.directory" | transloco }}
                    <svg
                        class="size-5 flex-none transition-transform duration-300 ease-in-out"
                        [class.rotate-180]="isMenuOpen"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        aria-hidden="true"
                        data-slot="icon"
                    >
                        <path
                            fill-rule="evenodd"
                            d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z"
                            clip-rule="evenodd"
                        />
                    </svg>
                </button>
            </div>

            @for (item of navigationItems(); track item.id) {
                @if (item.type === "page") {
                    <a
                        [href]="item.page_ref | pathFromItem: 'page'"
                        class="text-title-small text-neutral-20 hover:text-neutral-30 flex-initial cursor-pointer"
                        >{{ item.translations_refs | getTranslation: "title" }}</a
                    >
                } @else if (item.type === "url") {
                    <a
                        [href]="item.url"
                        class="text-title-small text-neutral-20 hover:text-neutral-30 flex-initial cursor-pointer"
                        >{{ item.translations_refs | getTranslation: "title" }}</a
                    >
                }
            }
        </div>
        <div class="hidden flex-initial items-center justify-end gap-4 lg:flex xl:gap-8">
            <button
                type="button"
                class="text-title-small text-neutral-20 hover:text-neutral-30 cursor-pointer"
                (click)="switchLanguage()"
            >
                {{ alternativeLanguageDefinition.label }}
            </button>
            @if (loginNavigationItem()?.url) {
                <a
                    [href]="loginNavigationItem()?.url"
                    class="text-primary text-title-small hover:text-primary-50 text-center"
                    >{{ loginNavigationItem()?.translations_refs | getTranslation: "title" }}</a
                >
            } @else if (loginNavigationItem()?.page_ref) {
                <a
                    [href]="loginNavigationItem()?.page_ref | pathFromItem: 'page'"
                    class="text-primary text-title-small hover:text-primary-50 text-center"
                    >{{ loginNavigationItem()?.translations_refs | getTranslation: "title" }}</a
                >
            }
            @if (membershipNavigationItem()?.page_ref) {
                <a
                    [href]="membershipNavigationItem()?.page_ref | pathFromItem: 'page'"
                    class="bg-primary text-title-small hover:bg-primary-50 rounded-md px-4 py-2 text-center text-white"
                    >{{ membershipNavigationItem()?.translations_refs | getTranslation: "title" }}</a
                >
            } @else if (membershipNavigationItem()?.url) {
                <a
                    [href]="membershipNavigationItem()?.url"
                    class="bg-primary text-title-small hover:bg-primary-50 rounded-md px-4 py-2 text-center text-white"
                    >{{ membershipNavigationItem()?.translations_refs | getTranslation: "title" }}</a
                >
            }
        </div>
        <div class="flex items-center justify-between gap-x-8 lg:hidden">
            @if (isMenuOpen) {
                <div class="text-body-small">
                    <button
                        type="button"
                        class="bg-primary text-body-medium w-full flex-1 cursor-pointer rounded-sm px-2 py-1 text-center text-white"
                        (click)="switchLanguage()"
                    >
                        {{ alternativeLanguageDefinition.label }}
                    </button>
                </div>
            }
            <button
                class="text-primary"
                [attr.aria-label]="
                    isMenuOpen ? ('navigation.close_menu' | transloco) : ('navigation.open_menu' | transloco)
                "
                [attr.aria-expanded]="isMenuOpen"
                (click)="toggleMenu()"
            >
                @if (isMenuOpen) {
                    <svg-icon
                        [svgStyle]="{ width: '20px', height: '20px' }"
                        src="assets/icons/Close.svg"
                        aria-hidden="true"
                    />
                } @else {
                    <svg-icon
                        [svgStyle]="{ width: '24px', height: '24px' }"
                        src="assets/icons/Navigation-Menu.svg"
                        aria-hidden="true"
                    />
                }
            </button>
        </div>
    </nav>

    <div class="navigation-menu" [class.scrolled]="isScrolled" [class.hidden]="!isMenuOpen">
        <div class="flex gap-x-6">
            @for (category of categories(); track category.id) {
                <a [href]="category | pathFromItem: 'category'" class="group flex flex-1 flex-col justify-between">
                    <div class="ml-4 size-28">
                        <img [ngSrc]="category.image | getDirectusImage" alt="Category Icon" width="112" height="112" />
                    </div>
                    <div class="mb-4 flex h-fit flex-col gap-y-1">
                        <h1 class="text-body-medium text-neutral-20">
                            {{ category.translations_refs | getTranslation: "title" }}
                        </h1>
                        <p class="text-label-large text-neutral-20">
                            {{ category.translations_refs | getTranslation: "description" }}
                        </p>
                    </div>
                    <div
                        class="text-primary text-body-small group-hover:text-primary-50 mt-auto flex items-center gap-x-2"
                    >
                        <span>{{ "navigation.explore" | transloco }}</span>
                        <svg-icon [svgStyle]="{ width: '16px', height: '16px' }" src="assets/icons/Arrow-Right.svg" />
                    </div>
                </a>
            }
        </div>
    </div>

    <div class="mobile-navigation-menu" aria-modal="true" [class.hidden]="!isMenuOpen">
        <div class="flex flex-1 flex-col gap-y-2 pb-4">
            @for (category of categories(); track category.id) {
                <a
                    [href]="category | pathFromItem: 'category'"
                    class="text-primary text-body-small flex items-center gap-x-4 px-6 py-2"
                >
                    <img [ngSrc]="category.icon | getDirectusImage" alt="Category Icon" width="32" height="32" />
                    <h1 class="text-body-medium text-neutral-20">
                        {{ category.translations_refs | getTranslation: "title" }}
                    </h1>
                </a>
            }
        </div>
        <div class="border-neutral-20/20 flex flex-1 flex-col gap-y-2 border-t py-2">
            @for (item of navigationItems(); track item.id) {
                @if (item.type === "page") {
                    <a [href]="item.page_ref | pathFromItem: 'page'" class="text-body-medium flex-initial px-6 py-2">{{
                        item.translations_refs | getTranslation: "title"
                    }}</a>
                } @else if (item.type === "url") {
                    <a [href]="item.url" class="text-body-medium flex-initial px-6 py-2">{{
                        item.translations_refs | getTranslation: "title"
                    }}</a>
                }
            }
        </div>

        <div class="border-neutral-20/20 flex flex-col items-center gap-y-3 border-t px-5 py-3">
            <a [href]="loginNavigationItem()?.url" class="text-primary text-title-small text-center">{{
                loginNavigationItem()?.translations_refs | getTranslation: "title"
            }}</a>
            <a
                [href]="membershipNavigationItem()?.page_ref | pathFromItem: 'page'"
                class="bg-primary text-title-small w-full flex-1 rounded-md px-4 py-2.5 text-center text-white"
                >{{ membershipNavigationItem()?.translations_refs | getTranslation: "title" }}</a
            >
        </div>
    </div>
</header>
